module.exports = __webpack_public_path__ + "img/taiyos.e0c865cd.gif";